import { Search, Text, VSpacer } from "@/components/DesignSystem";
import { ApiProduct } from '@api/interfaces';
import { Divider } from '@mui/material';
import { Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';

interface ProductListContentProps {
  emptyText?: string,
  isMobile: boolean,
  products: ApiProduct[],
  productsCount: number,
  search: string,
  setSearch: (search: string) => void,
  variant?: 'products' | 'redeemable',
}

export const ProductListContent = ({
  emptyText,
  isMobile,
  products,
  productsCount,
  search,
  setSearch,
  variant = 'redeemable',
}: ProductListContentProps) => {
  const { t } = useTranslation();
  const isRedeemable = variant === 'redeemable';

  return (
    <>
      {isRedeemable && (
        <Text category="body-xsmall">
          {t($ => $.common.redeemableProducts.disclaimer)}
        </Text>
      )}
      {isMobile ? (
        <>
          <VSpacer size="2" />
          <Text category="body-medium">
            {isRedeemable
              ? t($ => $.common.redeemableProducts.count, { count: productsCount })
              : t($ => $.common.products.count, { count: productsCount })}
          </Text>
        </>
      ) : (
        <Stack>
          <VSpacer size="5" />
          <Search
            fullWidth
            onChangeText={setSearch}
            placeholder={isRedeemable
              ? t($ => $.common.search.searchRedeemableProducts)
              : t($ => $.common.search.searchProducts)}
            testID="redeemable-products-search"
            value={search}
          />
          <VSpacer size="6" />
          <Text category="body-medium">
            {isRedeemable
              ? t($ => $.common.redeemableProducts.count, { count: productsCount })
              : t($ => $.common.products.count, { count: productsCount })}
          </Text>
        </Stack>
      )}
      <VSpacer size="5" />
      <Divider />
      <VSpacer size="2" />
      {products.length > 0 ? (
        products.map((product) => (
          <Stack key={product.id} py="8px">
            <Text category="body-large">{product.name}</Text>
          </Stack>
        ))
      ) : (
        emptyText && <Text category="body-medium">{emptyText}</Text>
      )}
    </>
  );
};
